import { useState } from "react"
import { ServiceBooking } from "../types/service.type"
import { httpGet } from "../services/Http.service"
import { apiUrl } from "../configs/config.constants"
import { AxiosResponse } from "axios"

export function useGetCustomerBooking() {
  const [isLoading, setIsLoading] = useState(false)
  const [bookings, setBookings] = useState<ServiceBooking[]>([])

  async function getCustomerBooking() {
    setIsLoading(true)
    httpGet(
      apiUrl.booking.customerList,
      {},
      {
        'Authorization': 'Bearer ' + localStorage.getItem('customer.accessToken'),
      }
    )
      .then((response: AxiosResponse<ServiceBooking[]>) => {
        setIsLoading(false)
        setBookings(response.data)
      })
      .catch((error) => {
        setIsLoading(false)
        console.error(error)
      })
  }
  return { isLoading, bookings, getCustomerBooking }
}
